import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Display,
  Header,
  Content,
  Footer,
  HardwareButtonWrapper,
  Labels
} from 'containers';

import { HeaderText } from 'components';
import { DisplayButton } from 'components/buttons';

import SettingsConfirmation from '../SettingsConfirmation/SettingsConfirmation';

import styles from './OilSettings.scss';

class OilSettings extends Component {
  constructor(props) {
    super(props);

    const { screens, routes } = this.props.content;
    const [entryScreen, ...confirmationScreens] = screens;

    this.state = {
      resetOil: null,
      confirmationStep: null,
      entryScreen,
      confirmationScreens,
      buttonConfig: {
        left: {
          destination: routes.left
        },
        center: {
          onClick: this.reset
        },
        right: {
          destination: routes.right
        }
      }
    };
  }

  reset = () => {
    this.setState({
      confirmationStep: 1
    });
  };

  resetOil = (resetOil) => {
    this.setState({
      resetOil,
      confirmationStep: 2
    });
  };

  resetCancel = () => {
    this.setState({
      confirmationStep: null
    });
  };

  resetConfirm = (confirmReset) => {
    const { id, resetValue, engineValues } = this.props;
    const { entryScreen, resetOil } = this.state;

    const shouldReset = (resetOil !== null) ? resetOil : confirmReset;
    const hours = (shouldReset) ? engineValues.reset : engineValues.normal;

    const newItem = { ...entryScreen.data[1] };
    newItem.num = hours;

    resetValue(id, newItem);
  };

  renderConfirmationScreen = (step, screens) => {
    let content = screens[0];
    let confirm = this.resetConfirm;
    let cancel = this.resetCancel;

    if (screens.length > 1) {
      if (step === 1) {
        confirm = this.resetOil;
        cancel = this.resetOil;
      }

      content = screens[step - 1];
    }

    return (
      <SettingsConfirmation
        content={content}
        onConfirm={confirm}
        onCancel={cancel}
      />
    );
  };

  render() {
    const {
      entryScreen,
      confirmationStep,
      confirmationScreens,
      buttonConfig
    } = this.state;

    let output;

    if (confirmationStep) {
      output = this.renderConfirmationScreen(confirmationStep, confirmationScreens);
    } else {
      output = [
        <Display key="display">
          <Header>
            <HeaderText value={entryScreen.title} />
          </Header>
          <Content>
            <Labels values={entryScreen.data} />
          </Content>
          <Footer>
            <DisplayButton src="icon-xm-left-arrow" />
            <DisplayButton src="icon-xm-reset" />
            <DisplayButton src="icon-xm-right-arrow" />
          </Footer>
        </Display>,
        <HardwareButtonWrapper key="buttons" config={buttonConfig} />
      ];
    }

    return <div className={styles.screenWrapper}>{output}</div>;
  }
}

OilSettings.propTypes = {
  content: PropTypes.shape({
    screens: PropTypes.arrayOf(PropTypes.object).isRequired,
    routes: PropTypes.objectOf(PropTypes.string).isRequired
  }).isRequired,
  engineValues: PropTypes.shape({
    normal: PropTypes.string,
    reset: PropTypes.string.isRequired
  }).isRequired,
  id: PropTypes.string.isRequired,
  resetValue: PropTypes.func.isRequired
};

export default OilSettings;



// WEBPACK FOOTER //
// ./src/screens/shared/Settings/OilSettings/OilSettings.js